/**
 * Created by robincoburn on 24/09/15.
 */
angular.module('qkr').directive('couponListOption', ($timeout, gettextCatalog) => ({
        restrict: 'E',
        scope: {
            selector: '=',
            val: '=',
            description: '=',
            binRanges: '=',
            privileged: '=',
            errors: '=',
            isEdit: '='
        },
        template: require('../../coupons/templates/couponListOption.html'),
        link(scope, element, attributes) {
            const masterCardBins = ['51', '52', '53', '54', '55'];

            scope.changeSelector = function(selected) {
                if (scope.isEdit) {
                    return;
                }

                scope.selector = selected;
            };

            scope.setBinRanges = function(binRanges) {
                scope.binRanges = binRanges;
            };

            scope.select2Options = {
                defineBinRange: {
                    multiple: true,
                    simple_tags: true,
                    tags: [],
                    tokenSeparators: [','],
                    formatNoMatches: '',
                    openOnEnter: false
                }
            };

            scope.setMcBins = function(rewardMasterCardBins) {
            	if (rewardMasterCardBins) {
                    scope.showMasterCardBinsOption = true;
                    scope.allMasterCardBins = true;
                    // Directive within directive HACK
                    angular.element('#allMCBins').scope().allMasterCardBins = true;
                    setAllMasterCardBins();
            	} else {
                    scope.showMasterCardBinsOption = false;
                    scope.binRanges = null;
                    $timeout(() => {
                        angular.element('#binRanges').scope().binRanges = scope.binRanges;
                    }, 0);
                }
            };

            scope.setAllMcBins = function(allMasterCardBins) {
                if (allMasterCardBins) {
                    setAllMasterCardBins();
                } else {
                    const binRangeElement = angular.element('#binRanges');
                    if (binRangeElement && binRangeElement.scope()) {
                        binRangeElement.scope().binRanges = scope.binRanges;
                    }
                }
            };

            const setAllMasterCardBins = function() {
                scope.binRanges = angular.copy(masterCardBins);

                const binRangeElement = angular.element('#binRanges');
                if (binRangeElement && binRangeElement.scope()) {
                    binRangeElement.scope().binRanges = scope.binRanges;
                }
            };

            const shouldShowMasterCardBinsOption = function() {
                if ((scope.binRanges && scope.binRanges.length === 0) || !scope.binRanges) {
                    return false;
                }

                return true;
            };

            const areAllMasterCardBinsSelected = function() {
                let haveAllMasterCardBins = true;

                if (!scope.binRanges || scope.binRanges.length !== masterCardBins.length) {
                    return false;
                }

                angular.forEach(scope.binRanges, (bin) => {
                    if (masterCardBins.indexOf(bin) === -1) {
                        haveAllMasterCardBins = false;
                    }
                });

                return haveAllMasterCardBins;
            };

            if (scope.isEdit) {
                scope.showMasterCardBinsOption = shouldShowMasterCardBinsOption();
                scope.allMasterCardBins = areAllMasterCardBinsSelected();
            } else {
                scope.showMasterCardBinsOption = false;
                scope.allMasterCardBins = true;
                setAllMasterCardBins();
            }
        }
    }));



// WEBPACK FOOTER //
// ./src/coupons/directives/couponListOption.js